export default __webpack_public_path__ + "static/media/icon-email.c4829a81.svg";